var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0003 2.66699C28.289 2.66699 29.3337 3.71166 29.3337 5.00033V9.05727C29.3337 10.4228 28.5748 11.6752 27.3644 12.3074L18.9887 16.6812C21.17 17.7769 22.667 20.0347 22.667 22.6422C22.667 26.3241 19.6822 29.3089 16.0003 29.3089C12.3184 29.3089 9.33366 26.3241 9.33366 22.6422C9.33366 20.0347 10.8306 17.7769 13.012 16.6812L4.63624 12.3074C3.42583 11.6752 2.66699 10.4228 2.66699 9.05727V5.00033C2.66699 3.71166 3.71166 2.66699 5.00033 2.66699H27.0003ZM16.0003 17.9755C13.423 17.9755 11.3337 20.0649 11.3337 22.6422C11.3337 25.2195 13.423 27.3089 16.0003 27.3089C18.5777 27.3089 20.667 25.2195 20.667 22.6422C20.667 20.0649 18.5777 17.9755 16.0003 17.9755ZM20.667 4.66566H11.3337V13.5483L15.846 15.9055C15.9427 15.956 16.058 15.956 16.1546 15.9055L20.667 13.547V4.66566ZM9.33366 4.66566L5.00033 4.66699C4.81623 4.66699 4.66699 4.81623 4.66699 5.00033V9.05727C4.66699 9.67797 5.01192 10.2473 5.5621 10.5346L9.33366 12.503V4.66566ZM27.0003 4.66699L22.667 4.66566V12.503L26.4385 10.5346C26.9887 10.2473 27.3337 9.67797 27.3337 9.05727V5.00033C27.3337 4.81623 27.1844 4.66699 27.0003 4.66699Z",
    fill: "#131542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/Reward.296f8cbbe288b3f938d363cfbad7eb68.svg";
export { ForwardRef as ReactComponent };